import type { ButtonHTMLAttributes, HTMLAttributes, PropsWithChildren } from 'react';

export function Button({ className = '', ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button className={`button ${className}`.trim()} {...props} />;
}

export function Card({ className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
  return <section className={`card ${className}`.trim()} {...props} />;
}

export type { PropsWithChildren };
